import { useState } from 'react';
import classNames from 'classnames';

import TableItem from './TableItem';
import SectionTitle from '../SectionTitle/SectionTitle';

import styles from '../SearchTravel/SearchTravel.module.scss';

const TravelCountryTable = ({ data }) => {
  const [boolClass, setBoolClass] = useState(false);

  const renderTableItems = (item, index) => {
    return (
      <TableItem
        className={styles.item}
        key={index}
        itemScope
        itemType='http://schema.org/ListItem'
      >
        {item}
      </TableItem>
    );
  };

  const renderTypes = (item) => {
    return (
      <TableItem
        className={styles.item}
        key={item?.type}
        // path={item?.icon?.path}
        alt={item?.icon?.alt}
        itemScope
        itemType='http://schema.org/ListItem'
      >
        {item?.type}
      </TableItem>
    );
  };

  const handlerScroll = ({ target }) => {
    const { scrollLeft } = target;

    setBoolClass(scrollLeft > 30);
  };

  const renderTableRows = (item) => {
    return (
      <div
        className={styles.prices}
        itemScope
        itemType='http://schema.org/ItemList'
      >
        {data?.table?.operators?.map((operator, index) => {
          return (
            <TableItem className={styles.item} key={index}>
              {item[operator] ? item[operator] : 'x'}
            </TableItem>
          );
        })}
      </div>
    );
  };

  return (
    <section
      className={classNames(styles['country-block'], 'small-margin')}
      itemScope
      itemType='http://schema.org/Table'
    >
      <div className={styles['country-block__inner']}>
        <div className={styles['country-block__head']}>
          <div className={styles['country-block__caption']}>
            {/* Will be added in future */}
            {/* {data?.country?.flag && (
              <img
                className={styles['country-block__icon']}
                src={data?.country?.flag}
                alt='flag image'
                loading="lazy"
              />
            )} */}
            <SectionTitle
              titleModify={classNames(
                'title--large',
                styles['country-block__subtitle'],
              )}
            >
              {data?.country?.name}
            </SectionTitle>
          </div>
        </div>
        <div
          className={classNames(styles['country-table'], {
            [styles['country-table__scrolled']]: boolClass,
          })}
          onScroll={handlerScroll}
        >
          <div className={styles.roamingResultTable}>
            <div className={styles.types}>
              <TableItem
                className={classNames(styles.item, styles.firstType)}
                // path={data?.table?.titleIcon?.path}
                alt={data?.table?.titleIcon?.alt}
              >
                {data?.table?.title}
              </TableItem>
              <div className={styles.typesSecondary}>
                {data?.table?.values?.map(renderTypes)}
              </div>
            </div>
            <div className={styles.scrollable}>
              <div className={styles.header}>
                {data?.table?.operators?.map(renderTableItems)}
              </div>
              <div className={styles.pricesWrapper}>
                {data?.table?.values?.map(renderTableRows)}
              </div>
            </div>
          </div>
        </div>
        {/* {data?.table?.bottom_text && (
          <div className={styles['country-block__bottom']}>
            <span className={styles['country-block__warning']}>
              {data?.table?.bottom_text}
            </span>
            <TwoArrow className={styles['country-block__arrow']} />
          </div>
        )} */}
      </div>
    </section>
  );
};

export default TravelCountryTable;
